import { debounce, escapeRegExp } from 'lodash';
import { useEffect, useState } from 'react';
import { useGetScheduleDefaultAssemblies } from 'src/hooks/api/assembly/useGetScheduleDefaultAssembly';
import { IAssemblyListing } from 'src/interfaces';

export const useFilteredAssemblies = (
  channelName?: string,
  layoutTypeId?: number,
  excludeAssemblyIds?: number[],
) => {
  const [inputValue, setInputValue] = useState<string>('');
  const [selectedAssembly, setSelectedAssembly] =
    useState<IAssemblyListing | null>(null);

  const {
    data: assembliesData = { pages: [], pageParams: [] },
    isLoading: isLoadingAssemblies,
    error: errorLoadingAssemblies,
    hasNextPage,
    fetchNextPage,
  } = useGetScheduleDefaultAssemblies([
    `channelName=${channelName}`,
    `layoutTypeId=${layoutTypeId}`,
    inputValue ? `name=${encodeURIComponent(escapeRegExp(inputValue))}` : '',
  ]);

  const getNextDefaultAssemblyPage = () => {
    if (hasNextPage) {
      fetchNextPage();
    }
  };

  const assemblyCardData = assembliesData.pages
    .flatMap((page) => page.assemblies)
    .filter((assembly) => !excludeAssemblyIds?.includes(assembly.id));

  useEffect(() => {
    if (
      selectedAssembly &&
      !isLoadingAssemblies &&
      !assemblyCardData.some((assembly) => assembly.id === selectedAssembly.id)
    ) {
      setSelectedAssembly(null);
    }
  }, [assemblyCardData, isLoadingAssemblies, selectedAssembly]);

  const searchAssemblies = debounce(async (value: string | string[]) => {
    if (typeof value === 'string') {
      setInputValue(value);
    }
  }, 300);

  return {
    assembliesData: assemblyCardData,
    isLoadingAssemblies,
    errorLoadingAssemblies,
    selectedAssembly,
    setSelectedAssembly,
    searchAssemblies,
    inputValue,
    getNextDefaultAssemblyPage,
  };
};
